import React from 'react';
import axios from "../../../../containers/api";
import {showCatchError, toEnglishNumbers} from "../../../../helpers/Utils";
import {Badge, CardBody, CardTitle, FormGroup, Input, Label} from "reactstrap";

class DriverSmartCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            id: this.props.driverSmartCard,
            smartCard: null
        };
    }

    componentDidMount() {
        this.do();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            this.setState({id: this.props.driverSmartCard});
        }
    }

    do = () => {
        this.props.showSpinner();
        axios.get('api/DriverApi/InquirDriverSmartCard?driverSmartCard=' + toEnglishNumbers(this.state.id))
            .then((res) => {
                this.props.hideSpinner();
                if (res.data === null) {
                    this.props.showAlert("هیچ اطلاعاتی موجود نیست", "info");
                } else {
                    this.setState({smartCard: res.data});
                    this.props.showAlert("استعلام با موفقیت انجام شد", "success");
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };

    render() {
        return (
            <CardBody>
                <CardTitle>
                    نتیجه استعلام کارت هوشمند راننده
                </CardTitle>

                <div className="d-flex flex-md-row flex-column flex-wrap justify-content-center align-items-center">
                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>کد هوشمند / ملی راننده</Label>
                        <Input value={this.state.smartCard && this.state.smartCard.cardNumber} readOnly/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>نام</Label>
                        <Input value={this.state.smartCard && this.state.smartCard.name} readOnly/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>نام خانوادگی</Label>
                        <Input value={this.state.smartCard && this.state.smartCard.family} readOnly/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>کد ملی</Label>
                        <Input value={this.state.smartCard && this.state.smartCard.nationalId} readOnly/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>تلفن همراه</Label>
                        <Input value={this.state.smartCard && this.state.smartCard.mobile} readOnly/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>نوع گواهینامه</Label>
                        <Input value={this.state.smartCard && this.state.smartCard.novE_GAVAHINAMEH} readOnly/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>تاریخ اعتبار کارت</Label>
                        <Input value={this.state.smartCard && this.state.smartCard.cardValidationDate && this.state.smartCard.cardValidationDate.year + '/' + this.state.smartCard.cardValidationDate.month + '/' + this.state.smartCard.cardValidationDate.day} readOnly/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>تاریخ اعتبار کارت سلامت</Label>
                        <Input value={this.state.smartCard && this.state.smartCard.tarikH_ETEBAR_KART_SALAMAT} readOnly/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1 d-flex flex-column">
                        <Label>وضعیت</Label>
                        <h4>
                            {this.state.smartCard && this.state.smartCard.isActive === true ?
                                <Badge color="success" className="text-center w-100">فعال</Badge>
                                :
                                <Badge color="danger" className="text-center w-100">غیرفعال</Badge>
                            }
                        </h4>
                    </FormGroup>
                </div>
            </CardBody>
        );
    }
}

export default DriverSmartCard;
